module.exports = __webpack_public_path__ + "img/widget-11.82adc119.png";